import React, { CSSProperties } from "react";
import Oval from "react-loader-spinner";
import { useSelector } from "react-redux";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

const styles = {
  loaderContainer: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1400
  } as CSSProperties
};

export default function Loader() {
  const LoaderSelector = useSelector((state) => state.loader);
  const { LoaderOpened } = LoaderSelector;

  return (
    <>
      {LoaderOpened ? (
        <div style={styles.loaderContainer}>
          <Oval
            height={60}
            width={60}
            color="#4fa94d"
            visible={true}
            secondaryColor="#4fa94d"
            type={"Oval"}
          />
        </div>
      ) : null}
    </>
  );
}

export function ManualLoader() {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1400
      }}
    >
      <Oval
        height={60}
        width={60}
        color="#4fa94d"
        visible={true}
        secondaryColor="#4fa94d"
        type={"Oval"}
      />
    </div>
  );
}
